// Die Einfrier-Regel der PDF-Vorschau — eigene Datei, damit PdfPreviewModal
// nur die Komponente exportiert (react-refresh/only-export-components).

import type { AppSettings, Report } from '../types';

/** Der eingefrorene Stand, aus dem die Vorschau erzeugt wird. */
export interface VorschauStand {
  schluessel: string;
  report: Report;
  settings?: AppSettings;
}

/**
 * Die Vorschau zeigt den Stand beim ÖFFNEN. Früher hing die Erzeugung an der
 * Objektidentität von `report`: jedes Autosave im Hintergrund lieferte ein
 * neues Objekt und stieß die komplette (bei 6051 minutenlange) Erzeugung
 * erneut an.
 *
 * Gibt `stand` UNVERÄNDERT (dasselbe Objekt) zurück, solange derselbe Bericht
 * gemeint ist — Schlüssel aus Projekt, Abschnitt, Nummer, bewusst nicht die
 * Objektidentität. Neu eingefroren wird nur, wenn ein ANDERER Bericht kommt
 * oder die Einstellungen beim Öffnen noch fehlten und jetzt da sind
 * (asynchron geladenes Profil). Eigene Vorschau-Optionen, die neu erzeugen
 * müssten, hat der Dialog nicht; Druckoptionen ändert man vorher.
 */
export const vorschauStandFuer = (stand: VorschauStand | null, report: Report, settings?: AppSettings): VorschauStand => {
  const m = report.metadata;
  const schluessel = `${m.globalData?.projectId ?? ''}|${m.sectionId ?? ''}|${m.inspectionNumber ?? ''}`;
  if (stand && stand.schluessel === schluessel && (stand.settings || !settings)) return stand;
  return { schluessel, report, settings };
};
